<template>
    <div>
        <v-tabs v-model="entryTab" class="mb-5">
            <v-tab v-for="(productName, index) in productNames" :key="index">{{ productName }}</v-tab>
        </v-tabs>
        <v-window v-model="entryTab">
            <v-window-item v-for="({component, entry}, index) in serviceForms" :key="index">
                <component
                    :is="component"
                    v-model="prepareBookRequests[selectedTourEntryIndex(entry)]"
                    :entry="entry"
                    :search-request="searchRequest"
                    :disabled="disabled"
                    @change-price="changePrice($event, selectedTourEntryIndex(entry))"
                />
            </v-window-item>
        </v-window>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import FlightExtraData from '@/components/account/modals/newOrderRequest/forms/FlightExtraData.vue'

    @Component({
        components: {
            FlightExtraData,
        },
    })
    export class PackageTourExtraData extends Vue {
        @Prop({required: true}) selectedTourEntries
        @Prop({required: true}) searchRequest
        @Prop({required: true}) prepareBookRequests
        @Prop({required: true, type: Boolean}) disabled

        entryTab = 0

        @Emit()
        changePrice(price, index) {
            return {price, index}
        }

        selectedTourEntryIndex(entry) {
            return this.selectedTourEntries.findIndex(({entryName}) => entry.entryName === entryName)
        }

        get specifiedTourEntries() {
            return this.selectedTourEntries.filter(({type}) => type === 'FLIGHT')
        }

        get productNames() {
            return this.specifiedTourEntries.map(({productName}) => productName)
        }

        get serviceForms() {
            return this.specifiedTourEntries.map(entry => {
                switch (entry.type) {
                    case 'FLIGHT':
                        return {
                            entry,
                            component: resolveComponent('FlightExtraData'),
                        }
                }
            })
        }
    }

    export default PackageTourExtraData
</script>
